import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  getDataWithJoin,
  insertData,
  parseCurrency,
  updateData,
} from "../../../../utils/SamuiUtils";
import { useNavigate } from "react-router-dom";
import CurrencyInput from "react-currency-input-field";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataAPtype,
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  const navigate = useNavigate();
  
  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent shortcuts when typing in input fields
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT') {
        return;
      }
      
      // ESC key - Cancel/Back
      if (event.key === 'Escape') {
        event.preventDefault();
          window.location.href = "/creditor";
      }
      
      // F10 key - Save
      if (event.key === 'F10') {
        event.preventDefault();
        if (mode === 'I') {
          handleSubmit();
        } else {
          handleUpdateAP();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [mode]);
  
  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        comp_id: window.localStorage.getItem("company"),
        ap_code: "",
        ap_name: "",
        ap_type: "",
        ap_shortname: "",
        ap_taxno: "",
        ap_add1: "",
        ap_add2: "",
        ap_add3: "",
        ap_province: "",
        ap_zipcode: "",
        ap_contact: "",
        ap_contact2: "",
        ap_tel: "",
        ap_tel2: "",
        ap_group: "",
        ap_refsalecode: "",
        ap_area: "",
        ap_status: "Y",
        ap_credit: 0,
        ap_vat: 0,
        ap_discount: 0.0,
        ap_branch: "",
        ap_bt_name: "",
      };
      // กำหนดค่าเริ่มต้นให้กับ form data
      setFormData(initialData);
      // กำหนดค่าเริ่มต้นให้กับ initial form data
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        ap_id: selectedData.AP_Id,
        comp_id: window.localStorage.getItem("company"),
        ap_code: selectedData.AP_Code,
        ap_name: selectedData.AP_Name,
        ap_type: selectedData.AP_Type,
        ap_shortname: selectedData.AP_ShortName,
        ap_taxno: selectedData.AP_TaxNo,
        ap_add1: selectedData.AP_Add1,
        ap_add2: selectedData.AP_Add2,
        ap_add3: selectedData.AP_Add3,
        ap_province: selectedData.AP_Province,
        ap_zipcode: selectedData.AP_Zipcode,
        ap_contact: selectedData.AP_Contact,
        ap_contact2: selectedData.AP_Contact2,
        ap_tel: selectedData.AP_Tel,
        ap_tel2: selectedData.AP_Tel2,
        ap_group: selectedData.AP_Group,
        ap_refsalecode: selectedData.AP_RefSaleCode,
        ap_area: selectedData.AP_Area,
        ap_status: selectedData.AP_Status,
        ap_credit: parseCurrency(selectedData.AP_Credit, 10),
        ap_vat: parseCurrency(selectedData.AP_Vat, 10),
        ap_discount: selectedData.AP_Discount,
        ap_branch: selectedData.AP_Branch,
        ap_bt_name: selectedData.AP_BT_Name,
      };
      // อัปเดตค่าให้กับ form data
      setFormData(initialData);
      // อัปเดตค่าให้กับ initial form data
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  // ฟังก์ชันที่ใช้ในการเปลี่ยนค่าของข้อมูลในฟอร์ม
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "ap_taxno") {
      if (/^\d*$/.test(value) && value.length <= 13) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === "ap_zipcode") {
      if (value.length <= 5) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const handleCurrencyChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleInsertAP = async () => {
    try {
      const { AP_Id, ...dataToInsert } = formData;
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      const res = await insertData("Tb_Set_AP", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error in handleInsertAP:", error);
      getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้");
    }
  };

  const formatValues = (data) => {
    const { ap_id, ...rest } = data;
    return rest;
  };

  const handleUpdateAP = async () => {
    try {
      const where = { ap_id: formData.ap_id }; // ส่งในรูปแบบ Object
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_AP", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize(selectedData?.AP_Id);
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData("Tb_Set_AP", `WHERE AP_Id = ${selectedData.AP_Id}`);
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      });
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (
        !formData.ap_code ||
        !formData.ap_name ||
        !formData.ap_type ||
        !formData.ap_status
      ) {
        getAlert(
          "WARNING",
          "โปรดกรอกข้อมูล รหัสเจ้าหนี้ ชื่อเจ้าหนี้  ประเภทเจ้าหนี้  สถานะ"
        );
        return;
      }
      if (
        formData.ap_code === initialFormData.ap_code &&
        formData.ap_name === initialFormData.ap_name &&
        formData.ap_type === initialFormData.ap_type &&
        formData.ap_shortname === initialFormData.ap_shortname &&
        formData.ap_taxno === initialFormData.ap_taxno &&
        formData.ap_add1 === initialFormData.ap_add1 &&
        formData.ap_add2 === initialFormData.ap_add2 &&
        formData.ap_add3 === initialFormData.ap_add3 &&
        formData.ap_province === initialFormData.ap_province &&
        formData.ap_zipcode === initialFormData.ap_zipcode &&
        formData.ap_contact === initialFormData.ap_contact &&
        formData.ap_contact2 === initialFormData.ap_contact2 &&
        formData.ap_tel === initialFormData.ap_tel &&
        formData.ap_tel2 === initialFormData.ap_tel2 &&
        formData.ap_group === initialFormData.ap_group &&
        formData.ap_refsalecode === initialFormData.ap_refsalecode &&
        formData.ap_area === initialFormData.ap_area &&
        formData.ap_status === initialFormData.ap_status &&
        formData.ap_credit === initialFormData.ap_credit &&
        formData.ap_vat === initialFormData.ap_vat &&
        formData.ap_discount === initialFormData.ap_discount &&
        formData.ap_branch === initialFormData.ap_branch &&
        formData.ap_bt_name === initialFormData.ap_bt_name
      ) {
        getAlert(
          "WARNING",
          "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
        );
        return;
      }
      if (mode === "I") {
        await handleInsertAP();
      } else if (mode === "U") {
        await handleUpdateAP();
      }
      setFormData({
        ap_id: "", // Int
        comp_id: window.localStorage.getItem("company"), // Int
        ap_code: "",
        ap_name: "",
        ap_type: "", // Int
        ap_shortname: "",
        ap_taxno: "",
        ap_add1: "",
        ap_add2: "",
        ap_add3: "",
        ap_province: "",
        ap_zipcode: "",
        ap_contact: "",
        ap_contact2: "",
        ap_tel: "",
        ap_tel2: "",
        ap_group: "",
        ap_refsalecode: "",
        ap_area: "",
        ap_status: "Y",
        ap_credit: 0, // Int
        ap_vat: 0, // Int
        ap_discount: "",
        ap_branch: "",
        ap_bt_name: "",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const checkApCode = async () => {
    const { item_id, ...dataToInsert } = formData;

    const resItemCode = await getDataWithJoin(
      `a.*`,
      `[dbo].[Tb_Set_AP] AS a`,
      `WHERE a.AP_Code = '${formData.ap_code}'`, ""
    );

    if (resItemCode && resItemCode.length > 0) {
      getAlert("FAILED", "มีรหัสเจ้าหนี้แล้ว");
      setFormData((prev) => ({ ...prev, ap_code: "" }));
    } else {
      getAlert("SUCCESS", "รหัสเจ้าหนี้นี้สามารถใช้ได้");
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/creditor" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลเจ้าหนี้</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label>รหัสเจ้าหนี้</label>
                <input type="text" className="form-control" name="ap_code" value={formData.ap_code || ""} onChange={handleChange} onBlur={checkApCode} />
              </div>
              <div className="col-md-4">
                <label>รหัสอ้างอิงการขาย</label>
                <input type="text" className="form-control" name="ap_refsalecode" value={formData.ap_refsalecode || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>เลขภาษี</label>
                <input type="text" className="form-control" name="ap_taxno" value={formData.ap_taxno || ""} onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label>ชื่อเจ้าหนี้</label>
                <input type="text" className="form-control" name="ap_name" value={formData.ap_name || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ชื่อย่อ</label>
                <input type="text" className="form-control" name="ap_shortname" value={formData.ap_shortname || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ประเภทเจ้าหนี้</label>
                <div className="input-group">
                  <select className="form-select" name="ap_type" value={formData.ap_type} onChange={handleChange} disabled={dataAPtype.length <= 0}>
                    {dataAPtype.map((type, index) => (
                      <option key={index} value={type.APType_Id}>{type.APType_Name}</option>
                    ))}
                  </select>
                  {dataAPtype.length <= 0 && (
                    <button onClick={() => navigate("/APtype")} className="btn btn-warning text-white" type="button">+</button>
                  )}
                </div>
              </div>
            </div>

            <h5 className="mt-4 mb-3 border-bottom pb-2">ข้อมูลธุรกิจ</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label>ชื่อธุรกิจ</label>
                <input type="text" className="form-control" name="ap_bt_name" value={formData.ap_bt_name || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>สาขา</label>
                <input type="text" className="form-control" name="ap_branch" value={formData.ap_branch || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>กลุ่ม</label>
                <input type="text" className="form-control" name="ap_group" value={formData.ap_group || ""} onChange={handleChange} />
              </div>
            </div>

            <h5 className="mt-4 mb-3 border-bottom pb-2">ที่อยู่</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label>ที่อยู่ 1</label>
                <input type="text" className="form-control" name="ap_add1" value={formData.ap_add1 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ที่อยู่ 2</label>
                <input type="text" className="form-control" name="ap_add2" value={formData.ap_add2 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ที่อยู่ 3</label>
                <input type="text" className="form-control" name="ap_add3" value={formData.ap_add3 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>พื้นที่</label>
                <input type="text" className="form-control" name="ap_area" value={formData.ap_area || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>จังหวัด</label>
                <input type="text" className="form-control" name="ap_province" value={formData.ap_province || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>รหัสไปรษณีย์</label>
                <input type="text" className="form-control" name="ap_zipcode" value={formData.ap_zipcode || ""} onChange={handleChange} />
              </div>
            </div>

            <h5 className="mt-4 mb-3 border-bottom pb-2">การติดต่อ</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label>ติดต่อ</label>
                <input type="text" className="form-control" name="ap_contact" value={formData.ap_contact || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>เบอร์โทร</label>
                <input type="text" className="form-control" name="ap_tel" value={formData.ap_tel || ""} onChange={handleChange} maxLength="10" />
              </div>
              <div className="col-md-6">
                <label>ติดต่อ (เพิ่มเติม)</label>
                <input type="text" className="form-control" name="ap_contact2" value={formData.ap_contact2 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>เบอร์โทร (เพิ่มเติม)</label>
                <input type="text" className="form-control" name="ap_tel2" value={formData.ap_tel2 || ""} onChange={handleChange} maxLength="10" />
              </div>
            </div>

            <h5 className="mt-4 mb-3 border-bottom pb-2">การเงิน</h5>
            <div className="row g-3">
              <div className="col-md-3">
                <label>เครดิต</label>
                <CurrencyInput className="form-control text-end" name="ap_credit" value={formData.ap_credit || ""} allowNegativeValue={false} onValueChange={(value, name) => handleCurrencyChange(value, name)} />
              </div>
              <div className="col-md-3">
                <label>ภาษีมูลค่าเพิ่ม</label>
                <CurrencyInput className="form-control text-end" name="ap_vat" value={formData.ap_vat || ""} allowNegativeValue={false} onValueChange={(value, name) => handleCurrencyChange(value, name)} />
              </div>
              <div className="col-md-3">
                <label>การลดราคา</label>
                <CurrencyInput className="form-control text-end" name="ap_discount" value={formData.ap_discount || ""} decimalsLimit={2} decimalScale={2} allowNegativeValue={false} onValueChange={(value, name) => handleCurrencyChange(value, name)} />
              </div>
              <div className="col-md-3">
                <label>สถานะ</label>
                <select className="form-select" name="ap_status" value={formData.ap_status || "Y"} onChange={handleChange}>
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>

            <div className="row mt-4">
              {mode !== "I" ? (
                <div className="d-flex justify-content-between align-items-center">
                  <button onClick={handleDelete} type="button" className="btn btn-danger btn-lg">ลบ</button>
                  <div className="d-flex gap-2">
                    <button onClick={() => (window.location.href = "/creditor")} type="button" className="btn btn-dark btn-lg">ยกเลิก ESC </button>
                    <button onClick={handleUpdateAP} type="button" className="btn btn-warning text-white btn-lg">บันทึก (F10)</button>
                  </div>
                </div>
              ) : (
                <div className="d-flex">
                  <FormAction onSubmit={handleSubmit} onUpdate={handleSubmit} onDelete={handleDelete} mode={mode} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
